module.exports = (opts) => {
  if (opts && opts.values && opts.weights) {
    var weightTable = []
    for (const [index, weight] of opts.weights.entries()) {
      weightTable.push({ weight: weight, id: index })
    }
    return {
      values: opts.values,
      weights: weightTable
    }
  } else { throw new Error('Options supplied are not valid') }
}



// WEBPACK FOOTER //
// ./src/private/scanners/wpick.js